var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("1-1")]),_c('el-button',{on:{"click":_vm.gonext}},[_vm._v("去1-2")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }